import { boletasTypes, vouchersTypes } from "../actions/types";

const initialState = {
  boletas: [],
  loading: false,
  vouchers: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case boletasTypes.OBTENER_BOLETAS_EXITO:
      return {
        ...state,
        boletas: action.payload,
        loading: false,
      };
    case boletasTypes.OBTENER_BOLETAS:
      return {
        ...state,
        loading: true,
      };
    case vouchersTypes.OBTENER_VOUCHERS:
      return {
        ...state,
        loading: true,
      };
    case vouchersTypes.OBTENER_VOUCHERS_EXITO:
      return {
        ...state,
        vouchers: action.payload,
        loading: false,
      };
    case vouchersTypes.GUARDAR_VOUCHER_EXITO:
      return {
        ...state,
        vouchers: state.vouchers.map((voucher) =>
          voucher.id_dt_matricula_proyecto === action.payload.id_dt_matricula_proyecto
            ? {
                ...voucher,
                archivo_voucher: action.payload.archivo_voucher,
                fecha_registro: action.payload.fecha_registro,
                area_registro: action.payload.area_registro,
              }
            : voucher,
        ),
      };
    default:
      return state;
  }
}
